import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { nameof } from '@symphony-solo/shared/utils/src';
import { IChooseLocationFeature } from './choose-location.feature.state';
import { ChooseLocationState } from './choose-location.state';

export const getChooseLocationState: MemoizedSelector<IChooseLocationFeature, ChooseLocationState> = createFeatureSelector<
  ChooseLocationState
>(nameof<IChooseLocationFeature>('ChooseLocationFeature'));

export const getIsLoading = createSelector(getChooseLocationState, (state: ChooseLocationState) => state.isLoading);

export const getIsMenuLoading = createSelector(getChooseLocationState, (state: ChooseLocationState) => state.isMenuLoading);

export const getFailures = createSelector(getChooseLocationState, (state: ChooseLocationState) => state.failures);

export const getChooseLocation = createSelector(getChooseLocationState, (state: ChooseLocationState) => state.chooseLocation);

export const getLocationTimeslot = createSelector(getChooseLocationState, (state: ChooseLocationState) => state.locationTimeslot);

export const getLocationMenus = createSelector(getChooseLocationState, (state: ChooseLocationState) => state.locationMenus);

export const getDeliveryLocation = createSelector(getChooseLocationState, (state: ChooseLocationState) => state.deliveryLocation);
export const updateBackBtnValue = createSelector(getChooseLocationState, (state: ChooseLocationState) => state.backBtnValue);

export const getSelectedLocation = createSelector(getChooseLocationState, (state: ChooseLocationState) => state.selectedLocation);

export const getSelectedTimeslot = createSelector(getChooseLocationState, (state: ChooseLocationState) => state.selectedTimeslot);

export const getIsTimeslotExpired = createSelector(getChooseLocationState, (state: ChooseLocationState) => state.isTimeslotExpired);

export const getLocationPropTypes = createSelector(getChooseLocationState, (state: ChooseLocationState) => state.locationPropTypes);

export const getAcceptedAgeRestrictionYears = createSelector(
  getChooseLocationState,
  (state: ChooseLocationState) => state.acceptedAgeRestrictionYears
);
